import { Settings } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconSettings12Line = createIcon(Settings, 12, "Line");
export const IconSettings16Line = createIcon(Settings, 16, "Line");
export const IconSettings20Line = createIcon(Settings, 20, "Line");
export const IconSettings24Line = createIcon(Settings, 24, "Line");
export const IconSettings32Line = createIcon(Settings, 32, "Line");
export const IconSettings48Line = createIcon(Settings, 48, "Line");
export const IconSettings64Line = createIcon(Settings, 64, "Line");
